﻿import { Component, OnInit, HostListener, Renderer } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { DOCUMENT } from "@angular/platform-browser";

// APP
//import { AuthenticationService } from '../../services/authentication.service';
import { SharedService } from '../../services/shared.service';

@Component({
    selector: 'app-infomenu',
    templateUrl: './infomenu.component.html'
    //providers: [AuthenticationService]
})
export class InfomenuComponent implements OnInit {

    projectId: number = 0;
    appName: string = '';
    appIdLabel: string = ''; 
    isLoggedin: boolean = false;

    constructor(
        private router: Router,
        private renderer: Renderer,
        private sharedService: SharedService
    ) {
        
    }

    ngOnInit() {

        let ids = this.sharedService.getJsonData("id");
        if (ids != null) {
            if (ids.projectId != null) {
                this.projectId = ids.projectId;
                this.appName = ids.appName;
                this.appIdLabel = ids.appIdLabel;
            }
        } 
        if (this.projectId <= 0)
            this.sharedService.navigateHome();
    }

    summary() {
        this.sharedService.navigateSummary();
    }

}
